import React from 'react';
import { colors, fonts } from '../tokens';

/**
 * StepCard – einheitliche "So geht's weiter"-Karte auf Page 4.
 * Active = orangener Akzent + CTA-Pille; sonst Standard.
 */
export const StepCard = ({ num, icon: Icon, active = false, title, desc, action }) => (
  <div
    style={{
      display: 'flex',
      gap: '10px',
      padding: '10px 12px',
      background: 'white',
      borderRadius: '9px',
      border: `1.5px solid ${active ? 'rgba(224,112,0,0.25)' : colors.border}`,
      height: '100%',
      boxSizing: 'border-box',
    }}
  >
    <div
      style={{
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        flexShrink: 0,
        border: `2px solid ${active ? colors.orange : '#CBD5E1'}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: fonts.display,
        fontWeight: 700,
        fontSize: '11px',
        color: active ? colors.orange : colors.slateLight,
        background: 'white',
      }}
    >
      {num}
    </div>
    <div style={{ flex: 1, overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '3px' }}>
        <Icon size={10} color={active ? colors.orange : colors.slateMid} strokeWidth={2} />
        <h3
          style={{
            fontFamily: fonts.display,
            fontSize: '10.5px',
            fontWeight: 700,
            color: colors.navy,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {title}
        </h3>
      </div>
      <p className="proposal-body" style={{ fontSize: '9px', lineHeight: 1.45 }}>{desc}</p>
      {action && (
        <div
          style={{
            marginTop: '4px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '3px',
            background: 'rgba(224,112,0,0.07)',
            border: '1px solid rgba(224,112,0,0.18)',
            borderRadius: '4px',
            padding: '3px 8px',
            fontFamily: fonts.body,
            fontSize: '8px',
            fontWeight: 600,
            color: colors.amberText,
          }}
        >
          &rarr; {action}
        </div>
      )}
    </div>
  </div>
);
